import { fromLonLat } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';

import { addFeaturesToLayer } from 'utils/map/layers';
import {
  isUavoStillActive,
  setBasicUavoStyle,
  setIFFColorIfChanged,
  setUavoRotation,
} from './common';

const updateUavosOnMap = (layer, allUavos, mappingUavos) => {
  removePreviousUavosNotPresetCurrently(layer, allUavos);
  const uavosNotAddedToLayerBefore = updateUavosAddedToLayerOrReturnGeojsonWithNew(
    layer,
    allUavos
  );
  addUavosToLayer(layer, uavosNotAddedToLayerBefore, mappingUavos);
};

const removePreviousUavosNotPresetCurrently = (
  layerVector,
  allCurrentVehicles
) => {
  const uavosDisplayiedOnMap = getFeaturesFromLayer(layerVector);
  if (!uavosDisplayiedOnMap) return;
  for (const uavoPreviousAdded of uavosDisplayiedOnMap) {
    if (!isUavoStillActive(uavoPreviousAdded, allCurrentVehicles))
      layerVector.getSource().removeFeature(uavoPreviousAdded);
  }
};

const getFeaturesFromLayer = layer =>
  layer?.getSource() ? layer.getSource().getFeatures() : null;

const updateUavosAddedToLayerOrReturnGeojsonWithNew = (layerVector, uavos) => {
  const features = [];
  for (const currentUavoData of uavos) {
    const uavoFeatureFromLayer = getUavoFeatureIfExist(
      layerVector,
      currentUavoData
    );
    if (uavoFeatureFromLayer) {
      updateUavoFeature(uavoFeatureFromLayer, currentUavoData);
    } else {
      features.push({
        type: 'Feature',
        geometry: currentUavoData.position,
        properties: { detail: 'uavo', data: currentUavoData },
      });
    }
  }

  return {
    type: 'FeatureCollection',
    features,
  };
};

const getUavoFeatureIfExist = (layer, featureData) => {
  if (!layer.getSource()) return null;
  const id = featureData.id ? featureData.id : featureData.uid;
  const existingUavoFeature = layer
    .getSource()
    .getFeatures()
    .find(
      layerFeature =>
        layerFeature.getProperties().data.id === id ||
        layerFeature.getProperties().data.uid === id
    );

  return existingUavoFeature || null;
};

const updateUavoFeature = (uavoFeature, currentUavoData) => {
  uavoFeature
    .getGeometry()
    .setCoordinates(fromLonLat(currentUavoData.position.coordinates));
  uavoFeature.setProperties({
    data: currentUavoData,
  });
  setIFFColorIfChanged(uavoFeature);
  setUavoRotation(uavoFeature);
};

const addUavosToLayer = (layer, uavosGeojson, mappingUavos) => {
  const uavosFeatures = generateFeaturesFromGeojson(uavosGeojson);
  setBasicUavoStyleForFeatures(uavosFeatures, mappingUavos);
  addFeaturesToLayer(layer, uavosFeatures);
};

const generateFeaturesFromGeojson = geojson => {
  const features = new GeoJSON().readFeatures(geojson, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
  });

  return features;
};

const setBasicUavoStyleForFeatures = (features, mappingUavos) => {
  for (const feature of features) {
    setBasicUavoStyle(feature, mappingUavos);
  }
};

const filterUavosSources = (allUavos, sourcesToDisplay) => {
  const filteredUavos = [];
  for (const uavo of allUavos) {
    if (sourcesToDisplay.includes(uavo.source)) {
      filteredUavos.push(uavo);
    }
    if (sourcesToDisplay.includes('aircraft') && uavo.type !== 'drone')
      filteredUavos.push(uavo);
  }

  return filteredUavos;
};

export { updateUavosOnMap, filterUavosSources };
